import "./title.css"

const Heading = () => {
    return (
        <div className="header-box">
            <h1 className="heading-title"> FAQ </h1>
        </div>
    );
}

export default Heading;